import React, { useState } from 'react';
import './navbar.css';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      <nav className="navbar ">
        <div className="container d-flex justify-content-between align-items-center">
        <div className=" d-block ">
        <svg aria-label="Vercel logomark" height="42" role="img" style={{ width: 'auto', overflow: 'visible' }} viewBox="0 0 74 64"><path d="M37.5896 0.25L74.5396 64.25H0.639648L37.5896 0.25Z" fill="#fff"></path></svg>
        {/* <img src={logo} alt='' className='logo rounded p-2 border-2 border-dark border-rounded' height="70px" width="fit-content" /> */}
        </div>
        <div className="desktopMenu">
          <Link to="home" smooth={true} duration={500} className="desktopMenuListItem">Home</Link>
          <Link to="skills" smooth={true} duration={500} className="desktopMenuListItem">About</Link>
          <Link to="Experience" smooth={true} duration={500} className="desktopMenuListItem">Experience</Link>
          <Link to="Works" smooth={true} duration={500} className="desktopMenuListItem">Portfolio</Link>
          <Link to="contact" smooth={true} duration={500} className="desktopMenuListItem">Contact</Link>
        </div>
        <div className="hamburger" onClick={toggleMobileMenu}>
          &#9776; {/* Hamburger icon */}
        </div>
        <div className={`mobileMenu ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to="home" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>Home</Link>
          <Link to="skills" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>About</Link>
          <Link to="Experience" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>Experience</Link>
          <Link to="contact" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>Contact</Link>
        </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
